import styled from 'styled-components'

export const SubHeader = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`
